import Collaborations from './Collaborations'

export default Collaborations
